import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

//import { Utilities } from './utilities';

@Injectable({
  providedIn: 'root'
})
export class LocalStoreManager {

  private syncKeys: string[] = [];

  private reservedKeys: string[] =
    [
      'sync_keys',
      'addToSyncKeys',
      'removeFromSyncKeys',
      'getSessionStorage',
      'setSessionStorage',
      'addToSessionStorage',
      'removeFromSessionStorage',
      'clearAllSessionsStorage'
    ];

  public static readonly DBKEY_USER_DATA = "user_data";
  private static readonly DBKEY_SYNC_KEYS = "sync_keys";

  public saveSessionData(data: any, key = LocalStoreManager.DBKEY_USER_DATA) {

    this.testForInvalidKeys(key);

    //this.removeFromSyncKeys(key);
    localStorage.removeItem(key);
    this.sessionStorageSetItem(key, data);
  }
  public savePermanentData(data: any, key = LocalStoreManager.DBKEY_USER_DATA) {

    this.testForInvalidKeys(key);

    this.removeFromSessionStorage(key);
    this.localStorageSetItem(key, data);
  }


  public exists(key = LocalStoreManager.DBKEY_USER_DATA) {

    let data = sessionStorage.getItem(key);

    if (data == null)
      data = localStorage.getItem(key);

    return data != null;
  }
  public getData(key = LocalStoreManager.DBKEY_USER_DATA) {

    this.testForInvalidKeys(key);

    let data = this.sessionStorageGetItem(key);

    if (data == null)
      data = this.localStorageGetItem(key);

    return data;
  }
  public getDataObject<T>(key = LocalStoreManager.DBKEY_USER_DATA, isDateType = false): T {

    let data = this.getData(key);

    if (data != null) {
      if (isDateType)
        data = new Date(data);

      return <T>data;
    }
    else {
      return null;
    }
  }
  public deleteData(key = LocalStoreManager.DBKEY_USER_DATA) {

    this.testForInvalidKeys(key);

    this.removeFromSessionStorage(key);
    localStorage.removeItem(key);
  }


  private localStorageSetItem(key: string, data: any) {
    localStorage.setItem(key, JSON.stringify(data));
  }
  private sessionStorageSetItem(key: string, data: any) {
    sessionStorage.setItem(key, JSON.stringify(data));
  }
  private localStorageGetItem(key: string) {
    return this.JSonTryParse(localStorage.getItem(key));
  }
  private sessionStorageGetItem(key: string) {
    return this.JSonTryParse(sessionStorage.getItem(key));
  }
  private removeFromSessionStorage(keyToRemove: string) {

    this.removeFromSessionStorageHelper(keyToRemove);
    //this.removeFromSyncKeysBackup(keyToRemove);

    //localStorage.setItem('removeFromSessionStorage', keyToRemove);
    //localStorage.removeItem('removeFromSessionStorage');
  }
  private removeFromSessionStorageHelper(keyToRemove: string) {

    sessionStorage.removeItem(keyToRemove);
    //this.removeFromSyncKeysHelper(keyToRemove);
  }
  private testForInvalidKeys(key: string) {

    if (!key)
      throw new Error("key cannot be empty")

    if (this.reservedKeys.some(x => x == key))
      throw new Error(`The storage key "${key}" is reserved and cannot be used. Please use a different key`);
  }
  private JSonTryParse(value: string) {
    try {
      return JSON.parse(value);
    }
    catch (e) {
      if (value === "undefined")
        return void 0;

      return value;
    }
  }


  public clearAllSessionsStorage() {

    this.clearInstanceSessionStorage();
    //localStorage.removeItem(LocalStoreManager.DBKEY_SYNC_KEYS);

    //localStorage.setItem('clearAllSessionsStorage', '_dummy');
    //localStorage.removeItem('clearAllSessionsStorage');
  }
  public clearInstanceSessionStorage() {

    sessionStorage.clear();
    this.syncKeys = [];
  }
  public clearLocalStorage() {
    localStorage.clear();
  }
}
